/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { Cuid } from './cuid'
import type { VideoFeedbackSource } from './videoFeedbackSource'

/**
 * 動画評価の入力型
 */
export interface SubmitVideoFeedbackInput {
  /** UserAgent */
  userAgent?: string
  /** IPアドレス */
  ipAddress?: string
  /** 埋め込み経由の場合のシナリオID */
  scenarioId?: Cuid
  /** 評価の発生元 */
  source: VideoFeedbackSource
  /** 参考になった場合はtrue、参考にならなかった場合はfalse */
  isHelpful: boolean
  /** 視聴セッションID */
  sessionId: string
  /** 動画ID */
  videoId: Cuid
}
